module.exports = __webpack_public_path__ + "img/1_014.13c11b0e.jpg";